import React from 'react';
import { getErrorHash } from '@jira/platform__error-reporting/src/getErrorHash.tsx';
import { FireOperationalAnalytics } from '@atlassian/jira-product-analytics-bridge';
import { CodeBlockWithCopyButton } from './code-block-with-actions/CodeBlockWithCopyButton.tsx';

export const ErrorHash = ({ error }: { error: Error }) => {
	const errorHash = getErrorHash(error);
	const source = `Hash ${errorHash}`;

	return (
		<>
			<FireOperationalAnalytics
				action="rendered"
				actionSubject="errorHash"
				attributes={{
					errorHash,
				}}
			/>
			<div role="note">
				<CodeBlockWithCopyButton source={source} copyCodeActionSubjectId="copyErrorHash" />
			</div>
		</>
	);
};
